/**
 * Form field options and configurations
 */

export const GENDER_OPTIONS = [
  { value: "", label: "Select Gender" },
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

export const DEGREE_OPTIONS = [
  "Bachelor's",
  "Master's",
  "PhD",
  "Diploma",
  "Certificate",
  "Other",
];

export const SOCIAL_MEDIA_PLATFORMS = [
  "LinkedIn",
  "Twitter",
  "Facebook",
  "Instagram",
  "GitHub",
  "Personal Website",
  "Other",
];

// Date format configurations
export const DATE_FORMATS = {
  DISPLAY: "dd/MM/yyyy",
  ISO: "yyyy-MM-dd",
  API: "yyyy-MM-dd",
};

// Age restrictions
export const AGE_RESTRICTIONS = {
  MIN_AGE: 18,
  MAX_AGE: 100,
};
